import { useCustomTranslation } from '../../../../hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCube } from '@fortawesome/pro-light-svg-icons';
import { NexelemTable } from '@nexelem/tanstack-table';
import { Button } from '@nexelem/components';
import { closeBillOfMaterialModal } from './BillOfMaterialModal';
import { useColumns } from './useColumns';
import { BillOfMaterialHeader } from './BillOfMaterialHeader';
import { createBillOfMaterialDataSource } from './createBillOfMaterialDataSource';

type BillOfMaterialTableProps = {
  taskId: string;
};

export const BillOfMaterialTable = ({ taskId }: BillOfMaterialTableProps) => {
  const { columns } = useColumns();
  const dataSource = createBillOfMaterialDataSource(taskId);
  const { t } = useCustomTranslation('common');
  const { tWrapper } = useCustomTranslation('products.productionPlan.billOfMaterial');

  return (
    <NexelemTable.Root columns={columns} dataSource={dataSource}>
      <BillOfMaterialHeader />
      <NexelemTable.Table noResultsText={t('table.noData')} />
      <NexelemTable.Footer showScrollUpButton={false}>
        <span className="flex items-center gap-2 text-s11-sb text-text-secondary-darker uppercase">
          <FontAwesomeIcon className="size-5! text-text-status-yellow-darker" icon={faCube} />
          {tWrapper('warehouseShortage')}
        </span>
        <Button variant="outlined" onClick={closeBillOfMaterialModal}>
          {t('common.close')}
        </Button>
      </NexelemTable.Footer>
    </NexelemTable.Root>
  );
};
